/**
 * @property {string} dateLocal - date in YYYY-MM-DD format
 * @property {string} startTime - start time in HH:mm format
 * @property {string} endTime - end time in HH:mm format
 * @property {Integer} candidateId - candidate Id
 */

export default class ExtendBookingDTO {
  constructor(dateLocal, startTime, endTime, candidateId) {
    this.dateLocal = dateLocal
    this.startTime = startTime
    this.endTime = endTime
    this.candidateId = candidateId
  }
}
